import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../../modals/confirm-modal/confirm-modal.component';
import { FirebaseService } from '../../../service/firebase.service';
import { TranslationPipe } from '../../../shared/pipes/translation.pipe';
import { LotteryComponent } from '../lottery/lottery.component';

@Component({
  selector: 'app-audio-import',
  templateUrl: './audio-import.component.html',
  styleUrls: ['./audio-import.component.scss']
})
export class AudioImportComponent implements OnInit {
  @Input('enable') enable: boolean;
  @Output() enableChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input('title') title: string;
  @Input('url') url: string;
  @Output() urlChange: EventEmitter<string> = new EventEmitter<string>();


  @Input('name') name: string;
  @Output() nameChange: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('uploadSound') uploadSound: ElementRef;


  @Input('type') type: string;
  private dialogRef: any;




  constructor(public dialog: MatDialog, public translation: TranslationPipe, private _firebase: FirebaseService, private lottery: LotteryComponent) { }

  ngOnInit(): void {
  //  console.log(this.lottery.config)
  }


  changeValue() {

    this.enableChange.emit(this.enable);
    this.urlChange.emit(this.url);
    this.nameChange.emit(this.name)

    this.lottery.changeValue();
    //console.log(this.lottery.config.sound[this.type].enable)
  }


  triggerUpload() {
    this.uploadSound.nativeElement.value = '';
    this.uploadSound.nativeElement.click()
  }
  uploadSoundMedia(e) {


    if (this.name.length > 0) {

      this._firebase.removeFileFromUrl(this.url).then(d => {

        this._firebase.uploadFiles(e.target.files, 'sound').then(d => {
          this.name = d[0].data.name;
          this.url = d[0].url;

          //console.log(d)
          this.changeValue();
        })
      })
    }
    else {
      this._firebase.uploadFiles(e.target.files, 'sound').then(d => {
        this.name = d[0].data.name;
        this.url = d[0].url;

       // console.log(d)
        this.changeValue();
      })
    }
  }

  removeSound(type) {
    
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmOperation'), ok: 'OK', cancel: this.translation.transform('cancel') }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this._firebase.removeFileFromUrl(this.url).then(d => {
          this.name = "";
          this.url = "";

          this.changeValue();
        })
      }

      else {

      }

    })

    

  }
}
